import axios from "axios";
import React, { createContext, useEffect, useState } from "react";


export let productContext = createContext();

export default function ProductContextProvider(props) {
 


  let headers = { token: localStorage.getItem("userToken") };

  function GetAllProductsWithSameCategoryid(id) {
    return axios.get(
      `https://vehex-production.up.railway.app/product/prouctsByCategory/${id}`
    );

  }







  return (
    <productContext.Provider
      value={{
        GetAllProductsWithSameCategoryid
       
      }}
    >
      {props.children}
    </productContext.Provider>
  );
}
